/**
 * @desc 明细
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(params: API.esca.eApi.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/eApi/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
